<div class="tarif-option-wrapper" [class.is-checked]="_isChecked" [class.is-disabled]="_isDisabled">
  <div class="tarif-header">
    <label class="width-full" [for]="radioBtn.inputId">
      <ng-content></ng-content>
    </label>

    @if (canExpand) {
      <acs-expand-button
        [disabled]="_isDisabled"
        [expanded]="expanded"
        (expandClick)="toggle($event)">
      </acs-expand-button>
    }
  </div>

  @if (expanded) {
    <div class="tarif-detail">
      <ng-content select="[details]"></ng-content>
    </div>
  }
</div>
